module.exports = __webpack_public_path__ + "static/img/email_icon.02bbe91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/email_icon.png
// module id = uMm2
// module chunks = 1